"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.Readable = factory();
  }
})(typeof self !== 'undefined' ? self : void 0, function () {
  'use strict';
  /* exported features */

  var features = {
    bind: !!function () {}.bind,
    classList: 'classList' in document.documentElement
  };
  /**
   * Extend.js
   * Merge defaults with user options
   * https://gist.github.com/cferdinandi/4f8a0e17921c5b46e6c4
   * @private
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   * @returns {Object} Merged values of defaults and options
   */

  var extend = function extend(defaults, options) {
    var extended = {};
    var prop;

    for (prop in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
        extended[prop] = defaults[prop];
      }
    }

    for (prop in options) {
      if (Object.prototype.hasOwnProperty.call(options, prop)) {
        extended[prop] = options[prop];
      }
    }

    return extended;
  };
  /**
   * Simple Two Way Binding
   * https://www.wintellect.com/data-binding-pure-javascript/
   * @private
   */


  var Binding = function Binding(b) {
    var _this = this;

    this.elementBindings = [];
    this.value = b.object[b.property];

    this.valueGetter = function () {
      return _this.value;
    };

    this.valueSetter = function (val) {
      _this.value = val;

      for (var i = 0; i < _this.elementBindings.length; i++) {
        var binding = _this.elementBindings[i];
        binding.element[binding.attribute] = val;
      }
    };

    this.addBinding = function (element, attribute, event) {
      var binding = {
        element: element,
        attribute: attribute
      };

      if (event) {
        element.addEventListener(event, function (event) {
          _this.valueSetter(parseInt(element[attribute]));
        });
        binding.event = event;
      }

      this.elementBindings.push(binding);
      element[attribute] = _this.value;
      return _this;
    };

    Object.defineProperty(b.object, b.property, {
      get: this.valueGetter,
      set: this.valueSetter
    });
    b.object[b.property] = this.value;
  };
  /**
   * Get/Set Settings
   * @private
   */


  function setSettings(options) {
    var saveData = [];
    options.inputs.forEach(function (input) {
      saveData.push(input.value);
    });
    console.log('saved', JSON.stringify(saveData, null, 2)); // Put the object into storage

    localStorage.setItem('readable', JSON.stringify(saveData));
  }

  function getSettings() {
    // Retrieve the object from storage
    var retrievedSettings = localStorage.getItem('readable');
    retrievedSettings = JSON.parse(retrievedSettings);
    console.log('retrieved', retrievedSettings);
    return retrievedSettings;
  }
  /**
   * Some string helper functions
   * https://www.wintellect.com/data-binding-pure-javascript/
   * @private
   */


  function removeDashes(string) {
    string = string.replace(/-/g, ' ');
    string = string.replace(/_/g, ' ');
    return string;
  }

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  function acronym(string) {
    string = removeDashes(string);
    var matches = string.match(/\b(\w)/g); // ['J','S','O','N']

    var acronym = matches.join(''); // JSON

    return acronym;
  }
  /**
   * Readable
   * Long Form readability tool for sighted users.
   * Exposes Typesettings, so the user can adjust to their own personal needs
   * Saves settings in local storage
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */


  function Readable(parent, elements, options) {
    // Check for Saved Settings
    var settings = getSettings();
    options = extend(options, Readable.options);
    console.log('options', options);

    if (settings) {
      settings.forEach(function (value, index) {
        options.inputs[index].value = value;
      });
    } // Store Options


    this.addRules = options.addRules;
    this.defaultStyles = options.defaultStyles;
    this.elements = elements;
    this.initialised = false;
    this.inputs = options.inputs.map(function (input) {
      input.id = options.namespace + '-' + input.type + '-' + acronym(input.name);
      input["class"] = options.namespace + '--' + input.type + '-' + acronym(input.name);
      input.label = toTitleCase(removeDashes(input.name)) + ':';
      input.labelClass = options.namespace + '--label-' + acronym(input.name);
      return input;
    });
    this.namespace = options.namespace;
    this.parent = parent;
    this.saved = settings;
    this.title = options.title;
  }

  Readable.prototype = {
    constructor: Readable,

    /**
     * Initialize Component
     * @private
     */
    init: function init() {
      if (!Readable.isSupported) {
        return;
      }

      if (this.defaultStyles) {
        this.addDefaultStyles();
        this.addTics();
      }

      this.createWidget(this.parent); // Set Values

      this.inputs.forEach(function (input) {
        var elements = this.elements;
        input.update(elements, input.value);
      }.bind(this)); // defer event registration to handle browser
      // potentially restoring previous scroll position
      // setTimeout(this.attachEvent.bind(this), 100);

      setTimeout(this.attachEvent.bind(this), 100);
      console.log('init', this);
      return this;
    },

    /**
     * Destroy Component
     * @private
     */
    // destroy: function() {
    // var element = document.getElementById(elementId);
    // document.removeEventListener('change');
    // element.parentNode.removeChild(element);
    // },

    /**
     * Generates Widget
     * @private
     */
    createWidget: function createWidget(target) {
      if (target) {
        var widget = document.createElement('div');
        var inputList = document.createElement('div');
        var title = document.createElement('small');
        var button = document.createElement('button'); // Create Widget Elemt

        widget.id = this.namespace;
        widget.classList.add(this.namespace); // Add Title

        title.innerHTML = this.title;
        widget.appendChild(title); // Add Input Container

        widget.appendChild(inputList); // Add Button

        button.id = 'save';
        button.innerHTML = 'Save';
        widget.appendChild(button); // Add Markup to Page

        target.appendChild(widget);
        this.createFormElements(inputList);
      } else {
        // throw err
        alert('target does not exist');
      }
    },
    addPresets: function addPresets() {
      var presets = [{
        name: 'Design',
        age: 2
      }, {
        name: 'Big',
        age: 8
      }, {
        name: 'Small',
        age: 1
      }];
    },

    /**
     * Generates Form Inputs
     * @private
     */
    createFormElements: function createFormElements(container) {
      /*
       * Input Templates
       * https://wesbos.com/template-strings-html/
       */
      var inputs = this.inputs; // Add Inputs

      inputs.forEach(function (input, index) {
        var markup = document.createElement('div');
        var type = input.type;
        var render = Readable.options.templates[type];
        markup.classList.add('input-group');
        markup.innerHTML = render(input);
        markup.classList.add('range');
        container.appendChild(markup);
      }); // Bind Inputs

      this.bindInputs(inputs, this);
    },

    /**
     * Binds Input Data to Model
     * @private
     */
    bindInputs: function bindInputs(inputs, scope) {
      inputs.forEach(function (input, index) {
        var selector = '.' + input.labelClass + ' span';
        var myInput = document.getElementById(input.id);
        var myLabel = document.querySelector(selector); // var styleBind = document.querySelector('.make-readable p');

        new Binding({
          object: scope.inputs[index],
          property: 'value'
        }).addBinding(myInput, 'value', 'change').addBinding(myLabel, 'innerHTML');
      });
    },

    /**
     * Handles Event Delegation
     * @private
     */
    attachEvent: function attachEvent() {
      if (!this.initialised) {
        this.initialised = true;
        /*
         * https://javascript.info/bubbling-and-capturing
         * https://gomakethings.com/listening-for-click-events-with-vanilla-javascript/
         */

        document.addEventListener('change', function (event) {
          var id = event.target.id;
          var elem = document.getElementById(id); // Used to Get Value

          var value = elem.value;
          var inputs = this.inputs;
          var elements = this.elements; // Don't follow the link

          event.preventDefault();
          inputs.forEach(function (input) {
            if (event.target.matches('#' + input.id)) {
              input.update(elements, value);
            }
          });
        }.bind(this), false);
        document.addEventListener('click', function (event) {
          if (event.target.matches('#save')) {
            setSettings(this);
          }
        }.bind(this), false);
      }
    },
    addDefaultStyles: function addDefaultStyles() {
      // Default Styles
      var style = document.createElement('style');
      style.innerHTML = '.' + this.namespace + ' {' + 'position: absolute;' + 'top: 0;' + 'right: -170px;' + 'z-index: 999;' + 'padding: 8px;' + 'margin: 8px;' + 'border: 2px solid #DCDCDC;' + 'border-radius: 3px;' + 'background-color: white;' + '}' + '.input-group {' + 'margin-top: 8px;' + 'margin-bottom: 8px;' + '}' + '.input-group label {' + 'display: block;' + 'font-size: 12px;' + 'font-weight: bold;' + '}' + '.input-radio {' + 'display: inline-block;' + '}' + '.input-slider {' + 'display: block;' + '}'; // Get the first script tag

      var ref = document.querySelector('head'); // Insert our new styles before the first script tag

      ref.parentNode.insertBefore(style, ref);
    },
    addTics: function addTics() {
      var rangeInputs = document.querySelectorAll('.range');
      rangeInputs.forEach(function (input) {
        var newElem = document.createElement('div');
        var ruler = createRules();
        input.appendChild(ruler);
      });

      function createRules() {
        var rulerElem = document.createElement('div');
        var fidelity = 5;
        var minRange = 0;
        var maxRange = 20;
        var delta = maxRange / fidelity;
        rulerElem.classList.add('ruler');

        for (var i = minRange; i <= maxRange; i += delta) {
          var tic = document.createElement('div');
          var ticSpan = document.createElement('span');
          ticSpan.innerHTML = i;
          tic.appendChild(ticSpan);
          rulerElem.appendChild(tic);
        }

        return rulerElem;
      }
    }
  };
  /**
   * Default options
   * @type {Object}
   */

  Readable.options = {
    parent: '.message',
    title: 'Change Typesetting',
    defaultStyles: true,
    addRules: true,
    namespace: 'readable',
    inputs: [{
      type: 'range',
      css: 'font-size',
      name: 'font-size',
      update: function update(elements, v) {
        elements.forEach(function (elem) {
          elem.style.fontSize = v + 'px';
        });
      },
      min: 14,
      max: 36,
      step: 1,
      value: 24
    }, {
      type: 'range',
      css: 'word-spacing',
      name: 'word-spacing',
      update: function update(elements, v) {
        elements.forEach(function (elem) {
          elem.style.wordSpacing = v + 'em';
        });
      },
      min: 0,
      max: 3,
      step: 0.1,
      value: 0
    }, {
      type: 'range',
      css: 'letter-spacing',
      name: 'letter-spacing',
      update: function update(elements, v) {
        elements.forEach(function (elem) {
          elem.style.letterSpacing = v / 10 + 'em';
        });
      },
      min: 0,
      max: 3,
      step: 0.1,
      value: 0
    }, {
      type: 'range',
      css: 'line-height',
      name: 'line-height',
      update: function update(elements, v) {
        elements.forEach(function (elem) {
          elem.style.lineHeight = v;
        });
      },
      min: 1,
      max: 3,
      step: 0.1,
      value: 1.4
    }],
    templates: {
      range: function range(input) {
        return "<label class=\"".concat(input.labelClass, "\" for=\"").concat(input.name, "\">").concat(input.label, " <span>").concat(input.value, "</span></label>\n                <input id=\"").concat(input.id, "\" name=\"").concat(input.name, "\" class=\"").concat(input["class"], "\" type=\"range\"  min=\"").concat(input.min, "\" max=\"").concat(input.max, "\" step=\"").concat(input.step, "\" />");
      } // checkbox: function(input) {
      //   return `<label class="${input.labelClass}" for="${input.name}">${input.label}</label>
      //           <input id="${input.id}" type="checkbox" name="${input.name}" value="${input.value}" class="${input.class}" />`;
      // },
      // select: function(input) {
      //   return `
      //   <div class="input-group select">
      //   <label for="${input.name}">${input.label}</label>
      //   <select>
      //       ${presets.map(
      //         preset =>
      //           `<option value=${presets.name}>${
      //             presets.name
      //           } is ${presets.age * 7}</option>`
      //       )}
      //   </select>
      //   </div>
      // `;
      // },

    }
  };
  Readable.isSupported = typeof features !== 'undefined' && features.bind && features.classList; // Just return a value to define the module export.
  // This example returns an object, but the module
  // can return a function as the exported value.

  return Readable;
});
"use strict";

/* PrismJS 1.16.0
https://prismjs.com/download.html#themes=prism-tomorrow&languages=markup+css+clike+javascript+json&plugins=command-line */
var _self = typeof window !== 'undefined' ? window // if in browser
: typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
: {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */


var Prism = function (_self) {
  // Private helper vars
  var lang = /\blang(?:uage)?-([\w-]+)\b/i;
  var uniqueId = 0;
  var _ = {
    manual: _self.Prism && _self.Prism.manual,
    disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
    util: {
      encode: function encode(tokens) {
        if (tokens instanceof Token) {
          return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
        } else if (Array.isArray(tokens)) {
          return tokens.map(_.util.encode);
        } else {
          return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
        }
      },
      type: function type(o) {
        return Object.prototype.toString.call(o).slice(8, -1);
      },
      objId: function objId(obj) {
        if (!obj['__id']) {
          Object.defineProperty(obj, '__id', {
            value: ++uniqueId
          });
        }

        return obj['__id'];
      },
      // Deep clone a language definition (e.g. to extend it)
      clone: function deepClone(o, visited) {
        var clone,
            id,
            type = _.util.type(o);

        visited = visited || {};

        switch (type) {
          case 'Object':
            id = _.util.objId(o);

            if (visited[id]) {
              return visited[id];
            }

            clone = {};
            visited[id] = clone;

            for (var key in o) {
              if (o.hasOwnProperty(key)) {
                clone[key] = deepClone(o[key], visited);
              }
            }

            return clone;

          case 'Array':
            id = _.util.objId(o);

            if (visited[id]) {
              return visited[id];
            }

            clone = [];
            visited[id] = clone;
            o.forEach(function (v, i) {
              clone[i] = deepClone(v, visited);
            });
            return clone;

          default:
            return o;
        }
      }
    },
    languages: {
      extend: function extend(id, redef) {
        var lang = _.util.clone(_.languages[id]);

        for (var key in redef) {
          lang[key] = redef[key];
        }

        return lang;
      },

      /**
       * Insert a token before another token in a language literal
       * As this needs to recreate the object (we cannot actually insert before keys in object literals),
       * we cannot just provide an object, we need an object and a key.
       * @param inside The key (or language id) of the parent
       * @param before The key to insert before.
       * @param insert Object with the key/value pairs to insert
       * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
       */
      insertBefore: function insertBefore(inside, before, insert, root) {
        root = root || _.languages;
        var grammar = root[inside];
        var ret = {};

        for (var token in grammar) {
          if (grammar.hasOwnProperty(token)) {
            if (token == before) {
              for (var newToken in insert) {
                if (insert.hasOwnProperty(newToken)) {
                  ret[newToken] = insert[newToken];
                }
              }
            } // Do not insert token which also occur in insert. See #1525


            if (!insert.hasOwnProperty(token)) {
              ret[token] = grammar[token];
            }
          }
        }

        var old = root[inside];
        root[inside] = ret; // Update references in other language definitions

        _.languages.DFS(_.languages, function (key, value) {
          if (value === old && key != inside) {
            this[key] = ret;
          }
        });

        return ret;
      },
      // Traverse a language definition with Depth First Search
      DFS: function DFS(o, callback, type, visited) {
        visited = visited || {};
        var objId = _.util.objId;

        for (var i in o) {
          if (o.hasOwnProperty(i)) {
            callback.call(o, i, o[i], type || i);

            var property = o[i],
                propertyType = _.util.type(property);

            if (propertyType === 'Object' && !visited[objId(property)]) {
              visited[objId(property)] = true;
              DFS(property, callback, null, visited);
            } else if (propertyType === 'Array' && !visited[objId(property)]) {
              visited[objId(property)] = true;
              DFS(property, callback, i, visited);
            }
          }
        }
      }
    },
    plugins: {},
    highlightAll: function highlightAll(async, callback) {
      _.highlightAllUnder(document, async, callback);
    },
    highlightAllUnder: function highlightAllUnder(container, async, callback) {
      var env = {
        callback: callback,
        selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
      };

      _.hooks.run("before-highlightall", env);

      var elements = env.elements || container.querySelectorAll(env.selector);

      for (var i = 0, element; element = elements[i++];) {
        _.highlightElement(element, async === true, env.callback);
      }
    },
    highlightElement: function highlightElement(element, async, callback) {
      // Find language
      var language = 'none',
          grammar,
          parent = element;

      while (parent && !lang.test(parent.className)) {
        parent = parent.parentNode;
      }

      if (parent) {
        language = (parent.className.match(lang) || [, 'none'])[1].toLowerCase();
        grammar = _.languages[language];
      } // Set language on the element, if not present


      element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;

      if (element.parentNode) {
        // Set language on the parent, for styling
        parent = element.parentNode;

        if (/pre/i.test(parent.nodeName)) {
          parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
        }
      }

      var code = element.textContent;
      var env = {
        element: element,
        language: language,
        grammar: grammar,
        code: code
      };

      var insertHighlightedCode = function insertHighlightedCode(highlightedCode) {
        env.highlightedCode = highlightedCode;

        _.hooks.run('before-insert', env);

        env.element.innerHTML = env.highlightedCode;

        _.hooks.run('after-highlight', env);

        _.hooks.run('complete', env);

        callback && callback.call(env.element);
      };

      _.hooks.run('before-sanity-check', env);

      if (!env.code) {
        _.hooks.run('complete', env);

        return;
      }

      _.hooks.run('before-highlight', env);

      if (!env.grammar) {
        insertHighlightedCode(_.util.encode(env.code));
        return;
      }

      if (async && _self.Worker) {
        var worker = new Worker(_.filename);

        worker.onmessage = function (evt) {
          insertHighlightedCode(evt.data);
        };

        worker.postMessage(JSON.stringify({
          language: env.language,
          code: env.code,
          immediateClose: true
        }));
      } else {
        insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
      }
    },
    highlight: function highlight(text, grammar, language) {
      var env = {
        code: text,
        grammar: grammar,
        language: language
      };

      _.hooks.run('before-tokenize', env);

      env.tokens = _.tokenize(env.code, env.grammar);

      _.hooks.run('after-tokenize', env);

      return Token.stringify(_.util.encode(env.tokens), env.language);
    },
    matchGrammar: function matchGrammar(text, strarr, grammar, index, startPos, oneshot, target) {
      for (var token in grammar) {
        if (!grammar.hasOwnProperty(token) || !grammar[token]) {
          continue;
        }

        if (token == target) {
          return;
        }

        var patterns = grammar[token];
        patterns = _.util.type(patterns) === "Array" ? patterns : [patterns];

        for (var j = 0; j < patterns.length; ++j) {
          var pattern = patterns[j],
              inside = pattern.inside,
              lookbehind = !!pattern.lookbehind,
              greedy = !!pattern.greedy,
              lookbehindLength = 0,
              alias = pattern.alias;

          if (greedy && !pattern.pattern.global) {
            // Without the global flag, lastIndex won't work
            var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
            pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
          }

          pattern = pattern.pattern || pattern; // Don’t cache length as it changes during the loop

          for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
            var str = strarr[i];

            if (strarr.length > text.length) {
              // Something went terribly wrong, ABORT, ABORT!
              return;
            }

            if (str instanceof Token) {
              continue;
            }

            if (greedy && i != strarr.length - 1) {
              pattern.lastIndex = pos;
              var match = pattern.exec(text);

              if (!match) {
                break;
              }

              var from = match.index + (lookbehind ? match[1].length : 0),
                  to = match.index + match[0].length,
                  k = i,
                  p = pos;

              for (var len = strarr.length; k < len && (p < to || !strarr[k].type && !strarr[k - 1].greedy); ++k) {
                p += strarr[k].length; // Move the index i to the element in strarr that is closest to from

                if (from >= p) {
                  ++i;
                  pos = p;
                }
              } // If strarr[i] is a Token, then the match starts inside another Token, which is invalid


              if (strarr[i] instanceof Token) {
                continue;
              } // Number of tokens to delete and replace with the new match


              delNum = k - i;
              str = text.slice(pos, p);
              match.index -= pos;
            } else {
              pattern.lastIndex = 0;
              var match = pattern.exec(str),
                  delNum = 1;
            }

            if (!match) {
              if (oneshot) {
                break;
              }

              continue;
            }

            if (lookbehind) {
              lookbehindLength = match[1] ? match[1].length : 0;
            }

            var from = match.index + lookbehindLength,
                match = match[0].slice(lookbehindLength),
                to = from + match.length,
                before = str.slice(0, from),
                after = str.slice(to);
            var args = [i, delNum];

            if (before) {
              ++i;
              pos += before.length;
              args.push(before);
            }

            var wrapped = new Token(token, inside ? _.tokenize(match, inside) : match, alias, match, greedy);
            args.push(wrapped);

            if (after) {
              args.push(after);
            }

            Array.prototype.splice.apply(strarr, args);
            if (delNum != 1) _.matchGrammar(text, strarr, grammar, i, pos, true, token);
            if (oneshot) break;
          }
        }
      }
    },
    tokenize: function tokenize(text, grammar) {
      var strarr = [text];
      var rest = grammar.rest;

      if (rest) {
        for (var token in rest) {
          grammar[token] = rest[token];
        }

        delete grammar.rest;
      }

      _.matchGrammar(text, strarr, grammar, 0, 0, false);

      return strarr;
    },
    hooks: {
      all: {},
      add: function add(name, callback) {
        var hooks = _.hooks.all;
        hooks[name] = hooks[name] || [];
        hooks[name].push(callback);
      },
      run: function run(name, env) {
        var callbacks = _.hooks.all[name];

        if (!callbacks || !callbacks.length) {
          return;
        }

        for (var i = 0, callback; callback = callbacks[i++];) {
          callback(env);
        }
      }
    },
    Token: Token
  };
  _self.Prism = _;

  function Token(type, content, alias, matchedStr, greedy) {
    this.type = type;
    this.content = content;
    this.alias = alias; // Copy of the full string this token was created from

    this.length = (matchedStr || "").length | 0;
    this.greedy = !!greedy;
  }

  Token.stringify = function (o, language) {
    if (typeof o == 'string') {
      return o;
    }

    if (Array.isArray(o)) {
      return o.map(function (element) {
        return Token.stringify(element, language);
      }).join('');
    }

    var env = {
      type: o.type,
      content: Token.stringify(o.content, language),
      tag: 'span',
      classes: ['token', o.type],
      attributes: {},
      language: language
    };

    if (o.alias) {
      var aliases = Array.isArray(o.alias) ? o.alias : [o.alias];
      Array.prototype.push.apply(env.classes, aliases);
    }

    _.hooks.run('wrap', env);

    var attributes = Object.keys(env.attributes).map(function (name) {
      return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
    }).join(' ');
    return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
  };

  if (!_self.document) {
    if (!_self.addEventListener) {
      // in Node.js
      return _;
    }

    if (!_.disableWorkerMessageHandler) {
      // In worker
      _self.addEventListener('message', function (evt) {
        var message = JSON.parse(evt.data),
            lang = message.language,
            code = message.code,
            immediateClose = message.immediateClose;

        _self.postMessage(_.highlight(code, _.languages[lang], lang));

        if (immediateClose) {
          _self.close();
        }
      }, false);
    }

    return _;
  } //Get current script and highlight


  var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();

  if (script) {
    _.filename = script.src;

    if (!_.manual && !script.hasAttribute('data-manual')) {
      if (document.readyState !== "loading") {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(_.highlightAll);
        } else {
          window.setTimeout(_.highlightAll, 16);
        }
      } else {
        document.addEventListener('DOMContentLoaded', _.highlightAll);
      }
    }
  }

  return _;
}(_self);

if (typeof module !== 'undefined' && module.exports) {
  module.exports = Prism;
} // hack for components to work correctly in node.js


if (typeof global !== 'undefined') {
  global.Prism = Prism;
}

;
Prism.languages.markup = {
  'comment': /<!--[\s\S]*?-->/,
  'prolog': /<\?[\s\S]+?\?>/,
  'doctype': /<!DOCTYPE[\s\S]+?>/i,
  'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
  'tag': {
    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/i,
    greedy: true,
    inside: {
      'tag': {
        pattern: /^<\/?[^\s>\/]+/i,
        inside: {
          'punctuation': /^<\/?/,
          'namespace': /^[^\s>\/:]+:/
        }
      },
      'attr-value': {
        pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/i,
        inside: {
          'punctuation': [/^=/, {
            pattern: /^(\s*)["']|["']$/,
            lookbehind: true
          }]
        }
      },
      'punctuation': /\/?>/,
      'attr-name': {
        pattern: /[^\s>\/]+/,
        inside: {
          'namespace': /^[^\s>\/:]+:/
        }
      }
    }
  },
  'entity': /&#?[\da-z]{1,8};/i
};
Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity']; // Plugin to make entity title show the real entity, idea by Roman Komarov

Prism.hooks.add('wrap', function (env) {
  if (env.type === 'entity') {
    env.attributes['title'] = env.content.replace(/&amp;/, '&');
  }
});
Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
  /**
   * Adds an inlined language to markup.
   *
   * An example of an inlined language is CSS with `<style>` tags.
   *
   * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addInlined('style', 'css');
   */
  value: function addInlined(tagName, lang) {
    var includedCdataInside = {};
    includedCdataInside['language-' + lang] = {
      pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
      lookbehind: true,
      inside: Prism.languages[lang]
    };
    includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
    var inside = {
      'included-cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        inside: includedCdataInside
      }
    };
    inside['language-' + lang] = {
      pattern: /[\s\S]+/,
      inside: Prism.languages[lang]
    };
    var def = {};
    def[tagName] = {
      pattern: RegExp(/(<__[\s\S]*?>)(?:<!\[CDATA\[[\s\S]*?\]\]>\s*|[\s\S])*?(?=<\/__>)/.source.replace(/__/g, tagName), 'i'),
      lookbehind: true,
      greedy: true,
      inside: inside
    };
    Prism.languages.insertBefore('markup', 'cdata', def);
  }
});
Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

(function (Prism) {
  var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
  Prism.languages.css = {
    'comment': /\/\*[\s\S]*?\*\//,
    'atrule': {
      pattern: /@[\w-]+[\s\S]*?(?:;|(?=\s*\{))/,
      inside: {
        'rule': /@[\w-]+/ // See rest below

      }
    },
    'url': {
      pattern: RegExp('url\\((?:' + string.source + '|[^\n\r()]*)\\)', 'i'),
      inside: {
        'function': /^url/i,
        'punctuation': /^\(|\)$/
      }
    },
    'selector': RegExp('[^{}\\s](?:[^{};"\']|' + string.source + ')*?(?=\\s*\\{)'),
    'string': {
      pattern: string,
      greedy: true
    },
    'property': /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
    'important': /!important\b/i,
    'function': /[-a-z0-9]+(?=\()/i,
    'punctuation': /[(){};:,]/
  };
  Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
  var markup = Prism.languages.markup;

  if (markup) {
    markup.tag.addInlined('style', 'css');
    Prism.languages.insertBefore('inside', 'attr-value', {
      'style-attr': {
        pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
        inside: {
          'attr-name': {
            pattern: /^\s*style/i,
            inside: markup.tag.inside
          },
          'punctuation': /^\s*=\s*['"]|['"]\s*$/,
          'attr-value': {
            pattern: /.+/i,
            inside: Prism.languages.css
          }
        },
        alias: 'language-css'
      }
    }, markup.tag);
  }
})(Prism);

Prism.languages.clike = {
  'comment': [{
    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
    lookbehind: true
  }, {
    pattern: /(^|[^\\:])\/\/.*/,
    lookbehind: true,
    greedy: true
  }],
  'string': {
    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    greedy: true
  },
  'class-name': {
    pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
    lookbehind: true,
    inside: {
      punctuation: /[.\\]/
    }
  },
  'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
  'boolean': /\b(?:true|false)\b/,
  'function': /\w+(?=\()/,
  'number': /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
  'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
  'punctuation': /[{}[\];(),.:]/
};
Prism.languages.javascript = Prism.languages.extend('clike', {
  'class-name': [Prism.languages.clike['class-name'], {
    pattern: /(^|[^$\w\xA0-\uFFFF])[_$A-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\.(?:prototype|constructor))/,
    lookbehind: true
  }],
  'keyword': [{
    pattern: /((?:^|})\s*)(?:catch|finally)\b/,
    lookbehind: true
  }, {
    pattern: /(^|[^.])\b(?:as|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
    lookbehind: true
  }],
  'number': /\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,
  // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
  'function': /[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
  'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
  'regex': {
    pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[(?:[^\]\\\r\n]|\\.)*]|\\.|[^/\\\[\r\n])+\/[gimyus]{0,6}(?=\s*($|[\r\n,.;})\]]))/,
    lookbehind: true,
    greedy: true
  },
  // This must be declared before keyword because we use "function" inside the look-forward
  'function-variable': {
    pattern: /[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/,
    alias: 'function'
  },
  'parameter': [{
    pattern: /(function(?:\s+[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)?\s*\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\))/,
    lookbehind: true,
    inside: Prism.languages.javascript
  }, {
    pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=>)/i,
    inside: Prism.languages.javascript
  }, {
    pattern: /(\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*=>)/,
    lookbehind: true,
    inside: Prism.languages.javascript
  }, {
    pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\s*)\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*\{)/,
    lookbehind: true,
    inside: Prism.languages.javascript
  }],
  'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
  'template-string': {
    pattern: /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}|[^\\`])*`/,
    greedy: true,
    inside: {
      'interpolation': {
        pattern: /\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}/,
        inside: {
          'interpolation-punctuation': {
            pattern: /^\${|}$/,
            alias: 'punctuation'
          },
          rest: Prism.languages.javascript
        }
      },
      'string': /[\s\S]+/
    }
  }
});

if (Prism.languages.markup) {
  Prism.languages.markup.tag.addInlined('script', 'javascript');
}

Prism.languages.js = Prism.languages.javascript;
Prism.languages.json = {
  'property': {
    pattern: /"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    greedy: true
  },
  'string': {
    pattern: /"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    greedy: true
  },
  'comment': /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
  'number': /-?\d+\.?\d*(e[+-]?\d+)?/i,
  'punctuation': /[{}[\],]/,
  'operator': /:/,
  'boolean': /\b(?:true|false)\b/,
  'null': {
    pattern: /\bnull\b/,
    alias: 'keyword'
  }
};

(function () {
  if (typeof self === 'undefined' || !self.Prism || !self.document) {
    return;
  }

  var clsReg = /(?:^|\s)command-line(?:\s|$)/;
  Prism.hooks.add('before-highlight', function (env) {
    var vars = env.vars = env.vars || {};
    var commandLine = vars['command-line'] = vars['command-line'] || {};

    if (commandLine.complete || !env.code) {
      commandLine.complete = true;
      return;
    } // Works only for <code> wrapped inside <pre> (not inline).


    var pre = env.element.parentNode;

    if (!pre || !/pre/i.test(pre.nodeName) || // Abort only if neither the <pre> nor the <code> have the class
    !clsReg.test(pre.className) && !clsReg.test(env.element.className)) {
      commandLine.complete = true;
      return;
    }

    if (env.element.querySelector('.command-line-prompt')) {
      // Abort if prompt already exists.
      commandLine.complete = true;
      return;
    }

    var codeLines = env.code.split('\n');
    commandLine.numberOfLines = codeLines.length;
    var outputLines = commandLine.outputLines = [];
    var outputSections = pre.getAttribute('data-output');
    var outputFilter = pre.getAttribute('data-filter-output');

    if (outputSections || outputSections === '') {
      // The user specified the output lines. -- cwells
      outputSections = outputSections.split(',');

      for (var i = 0; i < outputSections.length; i++) {
        // Parse the output sections into start/end ranges. -- cwells
        var range = outputSections[i].split('-');
        var outputStart = parseInt(range[0], 10);
        var outputEnd = range.length === 2 ? parseInt(range[1], 10) : outputStart;

        if (!isNaN(outputStart) && !isNaN(outputEnd)) {
          if (outputStart < 1) {
            outputStart = 1;
          }

          if (outputEnd > codeLines.length) {
            outputEnd = codeLines.length;
          } // Convert start and end to 0-based to simplify the arrays. -- cwells


          outputStart--;
          outputEnd--; // Save the output line in an array and clear it in the code so it's not highlighted. -- cwells

          for (var j = outputStart; j <= outputEnd; j++) {
            outputLines[j] = codeLines[j];
            codeLines[j] = '';
          }
        }
      }
    } else if (outputFilter) {
      // Treat lines beginning with this string as output. -- cwells
      for (var i = 0; i < codeLines.length; i++) {
        if (codeLines[i].indexOf(outputFilter) === 0) {
          // This line is output. -- cwells
          outputLines[i] = codeLines[i].slice(outputFilter.length);
          codeLines[i] = '';
        }
      }
    }

    env.code = codeLines.join('\n');
  });
  Prism.hooks.add('before-insert', function (env) {
    var vars = env.vars = env.vars || {};
    var commandLine = vars['command-line'] = vars['command-line'] || {};

    if (commandLine.complete) {
      return;
    } // Reinsert the output lines into the highlighted code. -- cwells


    var codeLines = env.highlightedCode.split('\n');

    for (var i = 0, l = (commandLine.outputLines || []).length; i < l; i++) {
      if (commandLine.outputLines.hasOwnProperty(i)) {
        codeLines[i] = commandLine.outputLines[i];
      }
    }

    env.highlightedCode = codeLines.join('\n');
  });
  Prism.hooks.add('complete', function (env) {
    var vars = env.vars = env.vars || {};
    var commandLine = vars['command-line'] = vars['command-line'] || {};

    if (commandLine.complete) {
      return;
    }

    var pre = env.element.parentNode;

    if (clsReg.test(env.element.className)) {
      // Remove the class "command-line" from the <code>
      env.element.className = env.element.className.replace(clsReg, ' ');
    }

    if (!clsReg.test(pre.className)) {
      // Add the class "command-line" to the <pre>
      pre.className += ' command-line';
    }

    var getAttribute = function getAttribute(key, defaultValue) {
      return (pre.getAttribute(key) || defaultValue).replace(/"/g, '&quot');
    }; // Create the "rows" that will become the command-line prompts. -- cwells


    var promptLines = new Array((commandLine.numberOfLines || 0) + 1);
    var promptText = getAttribute('data-prompt', '');

    if (promptText !== '') {
      promptLines = promptLines.join('<span data-prompt="' + promptText + '"></span>');
    } else {
      var user = getAttribute('data-user', 'user');
      var host = getAttribute('data-host', 'localhost');
      promptLines = promptLines.join('<span data-user="' + user + '" data-host="' + host + '"></span>');
    } // Create the wrapper element. -- cwells


    var prompt = document.createElement('span');
    prompt.className = 'command-line-prompt';
    prompt.innerHTML = promptLines; // Remove the prompt from the output lines. -- cwells

    for (var i = 0, l = (commandLine.outputLines || []).length; i < l; i++) {
      if (commandLine.outputLines.hasOwnProperty(i)) {
        var node = prompt.children[i];
        node.removeAttribute('data-user');
        node.removeAttribute('data-host');
        node.removeAttribute('data-prompt');
      }
    }

    env.element.insertBefore(prompt, env.element.firstChild);
    commandLine.complete = true;
  });
})();
"use strict";

(function () {
  // Tween Page Load
  document.querySelector('body').classList.add('tween'); // grab an element

  var parent = document.querySelector('.make-readable');
  var elements = document.querySelectorAll('.make-readable p'); // construct an instance of Readable, passing the element
  // var readable = new Readable(parent, elements, options);

  if (parent) {
    var readable = new Readable(parent, elements); // initialise

    readable.init();
  }
})();